// Route stub created by tools/gen_web_routes.py from contract/catalog/screens.json; owned by hand from here on.
import { createFileRoute } from '@tanstack/react-router'
import { SignUpScreen } from '../features/auth/SignUpScreen'
import { text } from '../shared/routing/search'

export const Route = createFileRoute('/sign-up')({
  staticData: { screenId: 'AuthSignUpScreen', access: 'flag signups.enabled' },
  // The route key's query arguments (screens.json `args`), as the apps' LinkResolver reads them;
  // unknown keys are dropped.
  validateSearch: (search: Record<string, unknown>): { email?: string; next?: string } => ({
    email: text(search.email),
    // `?next=` is the route key's returnTo (spec 08 § 3); `?returnTo=` from links sent before it still works.
    next: text(search.next) ?? text(search.returnTo),
  }),
  component: AuthSignUpScreen,
})

function AuthSignUpScreen() {
  const { email, next } = Route.useSearch()
  return <SignUpScreen email={email} returnTo={next} />
}
